import { useMutation } from '@tanstack/react-query';

import {
  BatchedBulkDeleteVoucherUsersPayload,
  BatchedBulkDeleteVoucherUsersResponse,
  BulkDeleteVoucherUsersPayload,
  BulkDeleteVoucherUsersResponse,
  bulkDeleteVoucherUsers,
  bulkDeleteVoucherUsersBatched,
} from '~/services/PromoService';

export function useBulkDeleteVoucherUsers() {
  return useMutation<BulkDeleteVoucherUsersResponse, Error, BulkDeleteVoucherUsersPayload>({
    mutationFn: async (payload) => bulkDeleteVoucherUsers(payload),
  });
}

export function useBatchedBulkDeleteVoucherUsers() {
  return useMutation<BatchedBulkDeleteVoucherUsersResponse, Error, BatchedBulkDeleteVoucherUsersPayload>({
    mutationFn: async (payload) => bulkDeleteVoucherUsersBatched(payload),
  });
}
